// @flow
import * as React from 'react'

import styles from './styles.module.scss'

export default props => {
    return (
        <div className={styles.container}>
            <h1>Please visit your unique and personal URL provided, to see your page.</h1>
        </div>
    )
}
